import { useState, useEffect } from "react";
// import useAxiosPrivate from "../hooks/useAxiosPrivate";
import axios from '../../api/axios';
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { formatDate } from "../../helpers/utils";
import LoadingModal from "../LoadingModal";
import styles from './Admin.module.css';
import { DragDropContext, Draggable } from "@hello-pangea/dnd";
import { StrictModeDroppable as Droppable } from "../../helpers/StrictModeDroppable";
import { formatItems } from "../../helpers/utils";
import _ from 'lodash';

const PollCategories = () => {
    const [pollCategories, setPollCategories] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        let isMounted = true;

        const getPollCategoriesController = new AbortController();

        const getPollCategories = async () => {

            try {
                const response = await axios.get('/pollcategories', {
                    signal: getPollCategoriesController.signal
                });
                console.log(response.data);
                if (isMounted) {
                    setPollCategories(response.data);
                    setDataLoaded(true);
                    setIsSaving(false);
                }
            } catch (err) {
                if (isMounted) {
                    console.error(err);
                    // if (err.response?.status === 403) {
                    //     navigate('/login', { state: { from: location }, replace: true });
                    // }
                }
            }
        }

        getPollCategories();

        return () => {
            isMounted = false;
            getPollCategoriesController.abort();
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handleOnDragEnd = (result) => {

        if (!result?.destination) return;

        const sourceIndex = result.source.index;
        const destinationIndex = result.destination.index;

        const newPollCategories = _.cloneDeep(pollCategories);
        const [category] = newPollCategories.splice(sourceIndex, 1);
        newPollCategories.splice(destinationIndex, 0, category);

        setPollCategories(newPollCategories);

    }

    const saveChanges = async () => {

        const displayOrder = [];

        let order = 1;
        for (let pollCategory of pollCategories) {
            displayOrder.push({
                pollCategoryId: pollCategory.pollCategoryId,
                displayOrder: order++
            })
        }

        const json = {
            displayOrder
        }

        setIsSaving(true);

        try {
            const response = await axios.patch(`/pollcategories`,
                JSON.stringify(json),
                {
                    headers: { 'Content-Type': 'application/json' }
                }
            );

            setPollCategories(response.data);
            setDataLoaded(true);
            setIsSaving(false);


        } catch (err) {
            console.log(err);
            // if (!err?.response) {
            //     setErrMsg('No Server Response');
            // } else if (err.response?.status === 409) {
            //     setErrMsg('Email Taken');
            // } else {
            //     setErrMsg('Registration Failed')
            // }
            // errRef.current.focus();
        }

    }

    const onEditCategory = (pollCategoryId) => {
        navigate(`/insightscategory/edit/${pollCategoryId}`);
    }

    if (!dataLoaded) {
        return <LoadingModal />;
    }

    console.log(`PollCategories: render at ${new Date().getTime()}`);

    return (
        <section className={styles.admin}>
            <p><Link to="/admin">Admin</Link> &gt; Insights Categories</p>
            <h1>Insights Categories</h1>
            <div className="surveys-list-container">
                <DragDropContext onDragEnd={handleOnDragEnd}>
                    <Droppable droppableId={"insightsCategories"}>
                        {(provided) => (
                            <div className="surveys-list" {...provided.droppableProps} ref={provided.innerRef}>
                                {
                                    pollCategories.map((pollCategory, i) => {
                                        return (
                                            <Draggable key={i} draggableId={i.toString()} index={i}>
                                                {(provided) => (
                                                    <div title={`${formatItems(pollCategory.surveys, "surveys")}, last edited ${formatDate(new Date((Date.parse(pollCategory.lastModified))))}`} key={i} className={pollCategory.status === "archived" ? "surveys-list-item archived" : "surveys-list-item"} {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
                                                        <label className="title">{pollCategory.category}</label>
                                                        <button className="edit" onClick={e => onEditCategory(pollCategory.pollCategoryId)}></button>
                                                    </div>
                                                )}
                                            </Draggable>
                                        )
                                    })
                                }
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>
            <button disabled={isSaving} onClick={saveChanges}>{isSaving ? "Saving..." : "Save changes"}</button>
        </section>
    );

    // return (
    //     <section className={styles.admin}>
    //         <h1>Insights Categories</h1>
    //         <div>
    //             {pollCategories?.length
    //                 ? (
    //                     <table className="standard">
    //                         <thead>
    //                             <tr>
    //                                 <th>ID</th>
    //                                 <th>Category</th>
    //                                 <th>Status</th>
    //                                 <th>Last update</th>
    //                             </tr>
    //                         </thead>
    //                         <tbody>
    //                             {pollCategories.map((pollCategory, i) => {
    //                                 return (
    //                                     <tr key={i}>
    //                                         <td><Link to={`/edit/${pollCategory.pollCategoryId}`}>{pollCategory.pollCategoryId}</Link></td>
    //                                         <td>{pollCategory.category}</td>
    //                                         <td>{pollCategory.status}</td>
    //                                         <td>{formatDate(new Date((Date.parse(pollCategory.lastModified))))}</td>
    //                                     </tr>
    //                                 )
    //                             })}
    //                         </tbody>
    //                     </table>
    //                 ) : <p>No poll categories to display</p>
    //             }
    //         </div>
    //     </section>
    // );

};

export default PollCategories;